import { MessagePosition, MessagesByPosition } from '@/shared/types/message';
import { MessageItem } from './MessageItem';
import { useMessageStyles } from '../../hooks/useMessageStyles';
import React from 'react';

interface MessagePositionsProps {
  messages: MessagesByPosition;
}

export const MessagePositions = React.memo(({ messages }: MessagePositionsProps) => {
  const { getPositionClasses } = useMessageStyles();

  if (Object.keys(messages).length === 0) {
    return null;
  }

  return (
    <>
      {Object.entries(messages).map(([position, positionMessages]) => {
        const validPosition = position as MessagePosition;

        if (
          process.env.NODE_ENV !== 'production' &&
          ![
            'top-left',
            'top-center',
            'top-right',
            'center-left',
            'center',
            'center-right',
            'bottom-left',
            'bottom-center',
            'bottom-right',
          ].includes(position)
        ) {
          // eslint-disable-next-line no-console
          console.warn(`[MessagePositions] Invalid position "${position}". Using as-is.`);
        }

        if (!positionMessages || positionMessages.length === 0) {
          return null;
        }

        return (
          <div
            key={position}
            className={`${getPositionClasses(validPosition)} ui-z-50 ui-max-w-[350px] ui-space-y-2`}
          >
            {positionMessages.map((messageItem) => {
              if (!messageItem.id) {
                if (process.env.NODE_ENV !== 'production') {
                  // eslint-disable-next-line no-console
                  console.warn('[MessagePositions] Message without id. Skipping.');
                }
                return null;
              }
              return <MessageItem key={messageItem.id} message={messageItem} />;
            })}
          </div>
        );
      })}
    </>
  );
});

MessagePositions.displayName = 'MessagePositions';
